import React from 'react';
import File from './file_row';
import {converteAddTimezone} from '@assets/js/helpers/date_helper';

class FilesList extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {monolitSettings} = this.props;
        let data = this.props.files;
        let files = [];
        for (let index in data) {
            let file = data[index];
            const createdDateConverted = converteAddTimezone(file.created_date, monolitSettings.timezone);
            files.push(
                <li key={index}>
                    <File key={index} {...file}/>
                    <div className="center file-upload-title">
                        (Загружен: {createdDateConverted}. Размер: {(file.size / 1024 / 1024).toFixed(2)} mb.)
                    </div>
                </li>
            );
        }
        if (!Object.keys(data).length) {
            files = 'Файлы не загружены';
        }
        return (
            <div className="filesList">
                {files}
            </div>
        );
    }
}
export default FilesList;
